import React from "react";
import styles from "./Privacy.module.css";

const Privacy = () => {
  return (
    <div className={styles.container}>
      <h1>Política de Privacidade</h1>

      <p>
        A sua privacidade é importante para nós. Esta política explica como o
        Fohattech coleta, usa e protege suas informações.
      </p>

      <h2>Coleta de informações</h2>
      <p>
        Podemos coletar informações básicas como dados de navegação, cookies e
        informações fornecidas voluntariamente pelo usuário.
      </p>

      <h2>Uso de cookies</h2>
      <p>
        Utilizamos cookies para melhorar a experiência do usuário, analisar
        tráfego e exibir conteúdos personalizados.
      </p>

      <h2>Publicidade</h2>
      <p>
        Este site pode exibir anúncios através de parceiros como o Google
        AdSense, que utilizam cookies para fornecer anúncios relevantes com base
        nas visitas do usuário.
      </p>

      <h2>Compartilhamento de dados</h2>
      <p>
        Não vendemos, trocamos ou transferimos suas informações pessoais para
        terceiros, exceto quando necessário para funcionamento do serviço.
      </p>

      <h2>Consentimento</h2>
      <p>
        Ao utilizar nosso site, você concorda com esta política de privacidade.
      </p>

      <h2>Atualizações</h2>
      <p>
        Esta política pode ser atualizada a qualquer momento para refletir
        melhorias ou mudanças no site.
      </p>
    </div>
  );
};

export default Privacy;